'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _goals = require('redux/modules/goals');

var goalActions = _interopRequireWildcard(_goals);

var _modules = require('redux/modules/modules');

var _components = require('components');

var _reactRouter = require('react-router');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module0App4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    profile: state.profile.data,
    app: state.moduleData.data.module0.app4,
    allModule: state.moduleData.data.module1,
    goals: state.goals.data
  };
}, (0, _extends3.default)({}, moduleActions, goalActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module0App4, _Component);

  function Module0App4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module0App4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module0App4.__proto__ || (0, _getPrototypeOf2.default)(Module0App4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 1,
      appId: 4,
      goals: _this.props.goals.goals.length === 3 ? _this.props.goals.goals : ['', '', ''], // because we expect 3 goals, so init array to 3
      priorityGoal: _this.props.goals.priorityGoal || '',
      isCompleted: _this.props.app.isCompleted || false,
      showModal: false
    }, _this.handlePriorityGoal = function (event) {
      var obj = {};
      obj.priorityGoal = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }
      obj.showModal = true;
      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      // this.props.updateModuleApp(this.props.user.userId, this.state.moduleId, this.state.appId, this.state);
      _this.props.updateModuleApp(_this.props.user.userId, 0, 4, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.updateGoals(_this.props.user.userId, _this.state);
    }, _this.nextModule = function () {
      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.close = function () {
      var obj = _this.state;
      obj.showModal = false;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Module0App4, [{
    key: 'handleChange',


    // handleAddGoal = () => {
    //   console.log('Add goal!');
    //   children.push(<ReactBootstrap.FormControl type="text" placeholder="Set a goal"/>);
    // }

    /*
     * Allows us to extract the user input
     * into the goals
     */
    value: function handleChange(index, event) {
      var obj = this.state;
      obj.goals[index] = event.target.value;
      this.setState(obj);
    }

    /*
     * Change the priority goal upon selecting a
     * radio button
     */


    /*
     * Handle when user finishes this module
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var profile = this.props.profile;

      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Getting Ready'
            ),
            _react2.default.createElement(
              'h2',
              null,
              'Importance of healthy eating after cancer treatment'
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'Thinking about what you have just learnt about the importance of healthy eating for and the effects of cancer treatment on children, what are some changes you\u2019d like to make to what ',
            profile.childName,
            ' eats, especially about fruit and vegetables.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Do you have any specific goals in mind or can you think of any goal relating to fruit or vegetables that you would like to work towards?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'During the next following modules we will be looking at strategies and skills you can use and steps you can take towards achieving some or all of these goals.'
          ),
          _react2.default.createElement(
            'p',
            { className: styles.orangeText },
            'Set 3 goals you would like to aim for!'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            null,
            this.state.goals.map(function (goal, index) {
              return _react2.default.createElement(
                'div',
                { key: 'goal' + index },
                _react2.default.createElement(ReactBootstrap.FormControl, { type: 'text', bsSize: 'large', placeholder: 'Set a goal', value: goal, onChange: _this2.handleChange.bind(_this2, index) }),
                _react2.default.createElement('br', null)
              );
            })
          ),
          (this.state.goals[0] !== '' || this.state.goals[1] !== '' || this.state.goals[2] !== '') && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'At the end of this module, we will look at strategies and skills you could use, and steps towards achieving some of these goals.'
            ),
            _react2.default.createElement(
              'h5',
              null,
              'Is there one goal in particular that you would like to prioritise?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handlePriorityGoal },
              this.state.goals.map(function (goal, index) {
                return _react2.default.createElement(
                  'div',
                  { key: 'priority' + index },
                  goal !== '' && _react2.default.createElement(
                    ReactBootstrap.Radio,
                    { name: 'priority', value: goal, checked: goal === _this2.state.priorityGoal },
                    goal
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          ),
          _react2.default.createElement(
            ReactBootstrap.Modal,
            { show: this.state.showModal, onHide: this.close },
            _react2.default.createElement(
              ReactBootstrap.Modal.Header,
              { closeButton: true },
              _react2.default.createElement(
                ReactBootstrap.Modal.Title,
                { className: styles.darkOrangeText },
                'You\'ve set your goals!'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Body,
              null,
              _react2.default.createElement(
                'p',
                null,
                'You\'ve successfully set your goals for Reboot Kids, your Profile will now contain the goals you have just set.'
              ),
              _react2.default.createElement(
                'p',
                null,
                _react2.default.createElement(
                  _reactRouter.Link,
                  { to: '/profile' },
                  'Click here'
                ),
                ' to go to your profile.'
              ),
              _react2.default.createElement(
                'p',
                null,
                'Otherwise, press ',
                _react2.default.createElement(
                  'strong',
                  null,
                  'Continue'
                ),
                ' to go to the next section.'
              )
            ),
            _react2.default.createElement(
              ReactBootstrap.Modal.Footer,
              null,
              _react2.default.createElement(
                ReactBootstrap.Button,
                { className: 'btn-success', onClick: this.nextModule },
                'Continue'
              )
            )
          )
        )
      );
    }
  }]);
  return Module0App4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  profile: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  goals: _propTypes2.default.object,
  updateModuleApp: _propTypes2.default.func,
  updateModule: _propTypes2.default.func,
  updateGoals: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module0App4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/App/App4.js
// module id = 1156
// module chunks = 0